/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Showpausebutton2Inputs */

const en_entity_showpausebutton2 = /** @type {(inputs: Entity_Showpausebutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Pause Button`)
};

const de_entity_showpausebutton2 = /** @type {(inputs: Entity_Showpausebutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause-Button anzeigen`)
};

/**
* | output |
* | --- |
* | "Show Pause Button" |
*
* @param {Entity_Showpausebutton2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_showpausebutton2 = /** @type {((inputs?: Entity_Showpausebutton2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Showpausebutton2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_showpausebutton2(inputs)
	return de_entity_showpausebutton2(inputs)
});
export { entity_showpausebutton2 as "entity_showPauseButton" }